import * as React from "react"
import {Box, Grid} from "@mui/material";

import PercentageChartNewElement from "./Element";
import PercentageChartNewLabel from "./Label";
import PercentageChartNewRowVersion from "./RowVErsion";
import PercentageChartNewColumnVersion from "./ColumnVersion";


export default function PercentageChartNew({ data=[], label='', column=false, highLevelPercentage=null }) {

	return column
		? <PercentageChartNewColumnVersion data={data} label={label} />
		: <PercentageChartNewRowVersion data={data} label={label} highLevelPercentage={highLevelPercentage} />
}